import React from "react";

function batchServiceSVGNew({
  isActive, 
  activeColor = "#232323",
  inactiveColor = "#868686" }: 
  { isActive: boolean; activeColor?: string; inactiveColor?: string; }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 22 22"
      fill={isActive ? activeColor : inactiveColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.84283 18.6854H5.28026C4.196 18.6854 3.31421 17.8036 3.31421 16.7193V5.2805C3.31421 4.19624 4.196 3.31445 5.28026 3.31445H5.84283C5.38721 3.84593 5.10153 4.52733 5.10153 5.2805V16.7193C5.10153 17.4725 5.38721 18.1539 5.84283 18.6854ZM15.8254 3.62866V6.17416H18.3709L15.8254 3.62866ZM18.6851 7.24655V16.7193C18.6851 17.8036 17.8034 18.6854 16.7191 18.6854H8.13997C7.05571 18.6854 6.17392 17.8036 6.17392 16.7193V5.2805C6.17392 4.19624 7.05571 3.31445 8.13997 3.31445H14.753V6.71036C14.753 7.00641 14.9932 7.24655 15.2892 7.24655H18.6851ZM15.6684 12.0506L14.2385 10.6208C14.029 10.4113 13.6897 10.4113 13.4803 10.6208C13.2709 10.8303 13.2709 11.1696 13.4803 11.379L13.9949 11.8935H9.56982C9.27377 11.8935 9.03363 12.1337 9.03363 12.4297C9.03363 12.7258 9.27377 12.9659 9.56982 12.9659H13.9949L13.4803 13.4804C13.2709 13.6899 13.2709 14.0292 13.4803 14.2386C13.5851 14.3433 13.7219 14.3957 13.8595 14.3957C13.997 14.3957 14.1338 14.3433 14.2386 14.2386L15.6684 12.8088C15.8779 12.5993 15.8778 12.26 15.6684 12.0506Z"
        fill={isActive ? activeColor : inactiveColor}
      />
    </svg>
  );
}

export default batchServiceSVGNew;
